export const circle = function circle(map, location, radius) {
    return new google.maps.Circle({
        strokeColor: '#5586ff',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#5586ff',
        fillOpacity: 0.3,
        map,
        center: location,
        radius,
    });
};

export const polyline = function polyline(routePath) {
    return new google.maps.Polyline({
        path: routePath,
        geodesic: true,
        clickable: true,
        strokeColor: '#FF0000',
    });
};

export const decodePath = function decodePath(points) {
    return google.maps.geometry ? google.maps.geometry.encoding.decodePath(points) : '';
};

export const boundsFromViewport = function boundsFromViewport(viewportObj) {
    return new google.maps.LatLngBounds(
        new google.maps.LatLng(viewportObj.southwest),
        new google.maps.LatLng(viewportObj.northeast)
    );
};

export const viewport = function viewport(map, viewportObj) {
    const rectangle = [
        { lat: viewportObj.northeast.lat, lng: viewportObj.northeast.lng },
        { lat: viewportObj.southwest.lat, lng: viewportObj.northeast.lng },
        { lat: viewportObj.southwest.lat, lng: viewportObj.southwest.lng },
        { lat: viewportObj.northeast.lat, lng: viewportObj.southwest.lng },
    ];
    return new google.maps.Polygon({
        paths: rectangle,
        strokeColor: '#5586ff',
        strokeOpacity: 0.85,
        strokeWeight: 1,
        fillColor: '#5586ff',
        fillOpacity: 0.3,
        map,
    });
};

export const viewpoint = function viewpoint(map, viewpointObj) {
    const viewportObj = {
        northeast: {
            lat: viewpointObj.bounds.north,
            lng: viewpointObj.bounds.east,
        },
        southwest: {
            lat: viewpointObj.bounds.south,
            lng: viewpointObj.bounds.west,
        },
    };
    return viewport(map, viewportObj);
};

export const extendedBounds = function extendedBounds(boundsArray) {
    const bounds = new google.maps.LatLngBounds();

    for (let i = 0; i < boundsArray.length; i++) {
        const locationA = new google.maps.LatLng(boundsArray[i].northeast.lat, boundsArray[i].southwest.lng);

        const locationB = new google.maps.LatLng(boundsArray[i].southwest.lat, boundsArray[i].northeast.lng);
        bounds.extend(locationA);
        bounds.extend(locationB);
    }

    return bounds;
};

export const woosmapBoundsFromViewport = function woosmapBoundsFromViewport(viewportObj) {
    return new window.woosmap.map.LatLngBounds(
        new window.woosmap.map.LatLng(viewportObj.southwest),
        new window.woosmap.map.LatLng(viewportObj.northeast)
    );
};

export const createWoosmapMap = (node) => {
    try {
        return new window.woosmap.map.Map(node);
    } catch (e) {
        console.error('Cound not instantiate a Map');
        console.error(e);
        return null;
    }
};
export class WoosmapMapBoundingBox {
    constructor(bounds, padding) {
        this.overlayView = new window.woosmap.map.OverlayView();

        this.bounds = !(bounds instanceof window.woosmap.map.LatLngBounds)
            ? new window.woosmap.map.LatLngBounds(
                  { lng: bounds.east, lat: bounds.north },
                  { lng: bounds.west, lat: bounds.south }
              )
            : bounds;

        this.padding = {
            right: padding?.right || 0,
            left: padding?.left || 0,
            top: padding?.top || 0,
            bottom: padding?.bottom || 0,
        };

        const self = this;

        this.overlayView.onAdd = () => {
            const panes = this.overlayView.getPanes();

            this.div = document.createElement('div');
            this.div.style.borderStyle = 'solid';
            this.div.style.borderWidth = '1px';
            this.div.style.borderColor = 'rgba(0, 0, 255, 0.8)';
            this.div.style.position = 'absolute';
            this.div.style.backgroundColor = 'rgba(0, 0, 255, 0.2)';

            panes.overlayLayer.appendChild(this.div);
        };

        this.overlayView.draw = () => {
            const overlayProjection = this.overlayView.getProjection();

            const sw = overlayProjection.fromLatLngToDivPixel(self.bounds.getSouthWest());
            const ne = overlayProjection.fromLatLngToDivPixel(self.bounds.getNorthEast());

            if (this.div) {
                this.div.style.left = `${sw.x - self.padding.left}px`;
                this.div.style.top = `${ne.y - self.padding.top}px`;
                this.div.style.width = `${ne.x - sw.x + (self.padding.left + self.padding.right)}px`;
                this.div.style.height = `${sw.y - ne.y + (self.padding.top + self.padding.bottom)}px`;
            }
        };

        this.overlayView.onRemove = () => {
            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                delete this.div;
            }
        };
    }

    setMap(map) {
        this.overlayView.setMap(map);
    }
}
